import {
  singleColorsEnum,
  dualColorsEnum,
  hairColorsEnum,
  dressDotsColors
} from "src/modules/avatar/baby-customization";

import decodeProtocolBuffer from "src/modules/protocol-buffers/decodeProtocolBuffer";
import { decodeBase64 } from "src/modules/protocol-buffers";

import protobuf from "protobufjs";

import protoRoot, { Type } from "./proto-root";
export { default } from "./proto-root";

function createCustomizationBuffer(payload) {
  const customization = Type.AvatarCustomization.create(payload);
  const buffer = Type.AvatarCustomization.encode(customization).finish();
  return buffer;
}

function encodeCustomizationToBase64(customizationBuffer) {
  return protobuf.util.base64.encode(
    customizationBuffer,
    0,
    customizationBuffer.length
  );
}

export function encodeBabyCustomization({
  dressColor,
  accessoryColor,
  hairColor,
  clothes,
  accessory,
  hair,
  nose,
  cheek,
  eye,
  skinColor
}) {
  const SkinColor = protoRoot.lookupEnum("babyCustomization.SkinColor");
  const SingleClothingColor = protoRoot.lookupEnum(
    "babyCustomization.SingleClothingColor"
  );
  const DualClothingColor = protoRoot.lookupEnum(
    "babyCustomization.DualClothingColor"
  );
  const HairColor = protoRoot.lookupEnum("babyCustomization.HairColor");
  const Clothes = protoRoot.lookupEnum("babyCustomization.Clothes");
  const Accessory = protoRoot.lookupEnum("babyCustomization.Accessory");
  const Hair = protoRoot.lookupEnum("babyCustomization.Hair");
  const Eye = protoRoot.lookupEnum("babyCustomization.Eye");
  const Cheek = protoRoot.lookupEnum("babyCustomization.Cheek");
  const Nose = protoRoot.lookupEnum("babyCustomization.Nose");

  const skinColorSelector = skinColor.replace("-", "_");
  const accessoryColorSelector = singleColorsEnum[accessoryColor];
  const hairColorSelector = hairColorsEnum[hairColor];

  const singleColorSelector =
    typeof dressColor === "object" ? undefined : singleColorsEnum[dressColor];
  const dualColorSelector =
    typeof dressColor === "object" ? dualColorsEnum[dressColor[1]] : undefined;

  const clothesColor = singleColorSelector
    ? { singleClothesColor: SingleClothingColor.values[singleColorSelector] }
    : {
        dualClothesColor: DualClothingColor.values[dualColorSelector]
      };

  const avatarCustomization = Type.AvatarCustomization.create({
    skinColor: SkinColor.values[skinColorSelector],
    accessoryColor: SingleClothingColor.values[accessoryColorSelector],
    hairColor: HairColor.values[hairColorSelector],
    clothes: Clothes.values[clothes],
    accessory: Accessory.values[accessory],
    hair: Hair.values[hair],
    eye: Eye.values[eye],
    cheek: Cheek.values[cheek],
    nose: Nose.values[nose],
    ...clothesColor
  });

  const customizationBuffer = createCustomizationBuffer(avatarCustomization);

  return encodeCustomizationToBase64(customizationBuffer);
}

function getEnumValue(_enum, valueToGet) {
  return Object.entries(_enum).reduce((result, [key, value]) => {
    if (value === valueToGet) result = key;
    return result;
  }, undefined);
}

export function decodeBabyCustomization(base64EncodedCustomization) {
  const bufferCustomization = decodeBase64(base64EncodedCustomization);
  const decodedCustomization = decodeProtocolBuffer({
    typePath: "babyCustomization.AvatarCustomization",
    buffer: bufferCustomization,
    root: protoRoot
  });

  let dressColor;
  const {
    skinColor,
    hairColor,
    accessoryColor,
    singleClothesColor,
    dualClothesColor
  } = decodedCustomization;

  if (singleClothesColor !== undefined) {
    dressColor = getEnumValue(singleColorsEnum, singleClothesColor);
  }

  if (dualClothesColor !== undefined) {
    dressColor = Object.entries(dualColorsEnum).reduce(
      (result, [key, value]) => {
        if (value === dualClothesColor) {
          dressDotsColors.forEach((pairOfColors) => {
            if (pairOfColors.includes(key)) result = pairOfColors;
          });
        }
        return result;
      },
      undefined
    );
  }
  delete decodedCustomization.singleClothesColor;
  delete decodedCustomization.dualClothesColor;

  return {
    ...decodedCustomization,
    skinColor: skinColor.replace("_", "-"),
    hairColor: getEnumValue(hairColorsEnum, hairColor),
    accessoryColor: getEnumValue(singleColorsEnum, accessoryColor),
    dressColor
  };
}
